<template>
  <div v-show="!showChat">
    <div v-show="showModal"
        class="contain__chat"
        tabindex="0"
    >
      <div
          :style="cssProps"
          class="chat__body box-shadow-2"
          @click="stopPropagation"
      >
        <div class="help_header">
          <h5 class="text-white mb-0">
            {{$t('sidebar.support_service')}}
          </h5>
          <b-form-checkbox
              :checked="this.userIsActive"
              class="custom-control-info m-0 p-0"
              inline
              switch
              @change="changeIcons"
          />
        </div>

        <div id="messages-window" class="select__contain p-2 rounded mb-auto">
          <div class="mb-1 mt-3">
            <b-list-group class="list__group box-shadow-1 border-0">
              <b-list-group-item
                  v-for="(item, i) in GET_CHAT_UNFINISHED_LIST"
                  :key="i"
                  class="d-flex align-items-center"
              >
                <b-link>#{{ item.id }}</b-link>
                <div class="text__ellepse pr-1">
                  {{ item.comment }}
                </div>
                <b-badge
                    :variant="item.status.color"
                    class="badge-round ml-auto"
                    pill
                >
                  {{ item.status.title }}
                </b-badge>
              </b-list-group-item>
            </b-list-group>

            <b-button
                v-if="
                GET_CHAT_UNFINISHED_LIST &&
                GET_CHAT_UNFINISHED_LIST.length < 3 &&
                !chatId
              "
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="mt-1 w-100"
                variant="primary"
                @click="createList"
            >
              {{$t('general.create')}}
            </b-button>
          </div>

          <div v-if="chatId">
            <b-button
                class="mb-1"
                variant="primary"
            >
              Тикет ID : {{ chatId }}
            </b-button>

            <validation-observer ref="validations">
              <validation-provider
                  #default="{ errors }"
                  name="Выберите тип проблемы"
                  rules="required"
              >
                <v-select
                    v-model="list.problem_type"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="GET_LIST_APPEAL_PROBLEM_TYPE"
                    :reduce="option => option.id"
                    class="mb-1 bg-white rounded w-100"
                    label="title"
                    :placeholder="$t('sla.choose_problem_type')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>

              <validation-provider
                  #default="{ errors }"
                  name="Выберите приоритет"
                  rules="required"
              >
                <v-select
                    v-model="list.priority"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="GET_LIST_APPEAL_PRIORITY_FILTER"
                    :reduce="option => option.id"
                    class="mb-1 bg-white rounded w-100"
                    label="title"
                    :placeholder="$t('sla.choose_priority')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>

              <validation-provider
                  #default="{ errors }"
                  :name="$t('contact.comment')"
                  rules="required"
              >
                <b-form-textarea
                    id="textarea-default"
                    v-model="list.comment"
                    :placeholder="$t('sla.comment')"
                    rows="3"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>

              <div class="mt-1">
                <b-form-file
                    ref="file-input"
                    v-model="list.file"
                    class="mb-1"
                    :placeholder="$t('choose_file_or_drop')"
                    :browse-text="$t('upload')"
                />

                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    class="w-100 mb-2"
                    variant="success"
                    @click="sendMessage"
                >
                  {{$t('send')}}
                </b-button>
              </div>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>

    <b-button
        v-if="!showChat"
        class="handle__open"
        variant="primary"
        @click="getChatData"
    >
      <feather-icon v-if="!showModal" icon="MessageSquareIcon" size="22"/>

      <feather-icon v-if="showModal" icon="XIcon" size="22"/>
    </b-button>
  </div>
</template>

<script>
import {
  BBadge,
  BButton,
  BFormCheckbox,
  BFormFile,
  BFormTextarea,
  BLink,
  BListGroup,
  BListGroupItem
} from 'bootstrap-vue'
import { required } from '@validations'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { getUserData } from '@/auth/utils'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'Chat',
  components: {
    BButton,
    BBadge,
    vSelect,
    BLink,
    BFormTextarea,
    BFormFile,
    BListGroup,
    BListGroupItem,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      userIsActive: '',
      is_loaded: false,
      checked: null,
      showModal: false,
      chatId: null,
      list: {
        problem_type: '',
        priority: '',
        url: null,
        comment: '',
        file: null,
      },
      cssProps: {
        backgroundImage: `url(${require('@/assets/images/BackgroundImg.png')})`,
      },
    }
  },
  mounted() {
    this.list.url = window.location.origin + this.$route.path
    this.userIsActive = getUserData().is_sla_open
    this.FETCH_LIST_APPEAL_PROBLEM_TYPE()
    this.FETCH_LIST_APPEAL_PRIORITY_FILTER()
    this.FETCH_CHAT_UNFINISHED_LIST()
    this.FETCH_CHAT_MESSAGE_DATA()
    this.FETCH_CHAT()
        .then(res => {
          if (res) {
              if(res.data) {
                  this.chatId = res.data.id
              }
          }
        })
  },
  computed: {
    ...mapState('listAppeal', ['showChat', 'chatIcon']),
    ...mapGetters('listAppeal', [
      'GET_LIST_APPEAL_PRIORITY_FILTER',
      'GET_LIST_APPEAL_PROBLEM_TYPE',
      'GET_LIST_APPEAL_CHAT_MESSAGE_DATA',
      'GET_CHAT',
      'GET_CHAT_UNFINISHED_LIST',
    ]),
  },
  methods: {
    ...mapActions('listAppeal', [
      'FETCH_LIST_APPEAL_PROBLEM_TYPE',
      'FETCH_LIST_APPEAL_PRIORITY_FILTER',
      'FETCH_LIST_APPEAL_STATUS_FILTER',
      'CREATE_CHAT_MESSAGE',
      'FETCH_CHAT_MESSAGE_DATA',
      'UPDATE_CHAT_MESSAGE_DATA',
      'FETCH_CHAT',
      'FETCH_CHAT_UNFINISHED_LIST',
      'FETCH_LIST_APPEAL',
      'UPDATE_USER_STATUS',
    ]),
    ...mapMutations('listAppeal', ['SET_OPEN_CHAT_ICON']),

    changeIcons(value) {
      this.UPDATE_USER_STATUS({
        is_sla_open: value,
      })
      this.SET_OPEN_CHAT_ICON(value)
    },

    async createList() {
      const formData = new FormData()
      formData.append('url', this.list.url)
      await this.CREATE_CHAT_MESSAGE(formData)
          .then(res => {
            this.FETCH_CHAT_MESSAGE_DATA()
            this.FETCH_CHAT()
                .then(resp => {
                  if (resp.is_success) {
                    this.chatId = resp.data.id
                    this.FETCH_CHAT_MESSAGE_DATA()
                  }
                })
          })
    },
    stopPropagation(event) {
      event.stopPropagation()
    },
    async sendMessage() {
      this.$refs.validations.validate()
          .then(success => {
            if (success) {
              const formData = new FormData()
              this.list.file ? formData.append('file', this.list.file) : null
              formData.append('problem_type', this.list.problem_type)
              formData.append(
                  'url',
                  (this.list.url = window.location.origin + this.$route.path),
              )
              formData.append('priority', this.list.priority)
              formData.append('comment', this.list.comment)
              formData.append('id', this.chatId)
              this.UPDATE_CHAT_MESSAGE_DATA(formData)
                  .then(() => {
                    this.FETCH_LIST_APPEAL()
                        .then(resp => {
                          if (resp.is_success) {
                            this.chatId = resp.data.id
                          } else {
                            this.chatId = null
                          }
                        })
                        .catch(err => {
                          this.$_errToast(err)
                        })
                    this.FETCH_CHAT_UNFINISHED_LIST()
                    this.showModal = false

                    this.list = {
                      problem_type: '',
                      priority: '',
                      comment: '',
                      file: null,
                    }
                  })
                  .catch(err => {
                    this.$_errToast(err)
                  })
            }
          })
    },
    async getChatData() {
      this.showModal = !this.showModal
      if (this.showModal) {
        await this.FETCH_CHAT(this.chatId)
      }
    },
  },
  watch: {
    '$route.path': {
      handler(newValue) {
        this.list.url = window.location.origin + newValue
      },
    },
  },
  directives: {
    Ripple,
  },
}
</script>

<style scoped>
#messages-window {
  height: 300px;
}

.help_header {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #4839eb;
  padding: 10px;
  width: 100%;
}

.chat__body {
  position: absolute;
  right: 20px;
  bottom: 85px;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  overflow: auto;
  width: 400px;
  height: 535px;
}

.contain__chat {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 22px;
  background-color: rgba(34, 41, 47, 0.55);
  height: 100vh;
  width: 100%;
  z-index: 9999;
}

.handle__open {
  position: fixed;
  bottom: 25px;
  right: 20px;
  border-radius: 100%;
  padding: 13px;
  z-index: 9999;
}

.text__ellepse {
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 14px;
}
</style>
